import { Power2 } from 'gsap';

export const SLIDE_IN_LEFT = {
  FROM: {
    x: 75,
    opacity: 0,
  },
  TO: {
    x: 0,
    opacity: 1,
    ease: Power2.easeOut,
  },
  DURATION: 0.4,
};

export const SLIDE_IN_RIGHT = {
  FROM: {
    x: -75,
    opacity: 0,
  },
  TO: {
    x: 0,
    opacity: 1,
    ease: Power2.easeOut,
  },
  DURATION: 0.4,
};

export const SLIDE_UP = {
  FROM: { opacity: 0, autoAlpha: 0, y: 75 },
  TO: { opacity: 1, autoAlpha: 1, y: 0 },
  DURATION: 0.4,
};

export const SLIDE_DOWN = {
  FROM: { opacity: 0, autoAlpha: 0, y: -75 },
  TO: { opacity: 1, autoAlpha: 1, y: 0 },
  DURATION: 0.8,
};

export const ANIMATION_DURATION = {
  NORMAL: 600,
  FAST: 400,
  SLOW: 800,
};
